import React from "react";
import { Card, Typography } from "@mui/material";

export default function InfoCard({
    title,
    description,
    children,
    sx = {},
    ...props
}) {
    return (
        <Card
            variant="outlined"
            sx={{
                p: 3,
                backgroundColor: "primary.50",
                borderColor: "primary.200",
                borderRadius: 4,
                // mt: 2,
                ...sx,
            }}
            {...props}
        >
            {title && (
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: "bold",
                        mb: 1,
                        color: "primary.800",
                    }}
                >
                    {title}
                </Typography>
            )}

            {description && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    {description}
                </Typography>
            )}

            {children}
        </Card>
    );
}
